import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Spin } from 'antd';
import TerminalFichada from './terminalFichada.js';

const FichadaPublica = () => {
  const [searchParams] = useSearchParams();
  const qrToken = searchParams.get('t');
  const [valido, setValido] = useState(null);

  useEffect(() => {
    const validar = async () => {
      if (!qrToken) {
        setValido(false);
        return;
      }
      try {
        const base = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
        const res = await fetch(`${base}/fichada/validar-token?t=${encodeURIComponent(qrToken)}`);
        const data = await res.json();
        setValido(data.valido);
      } catch {
        setValido(false);
      }
    };
    validar();
  }, [qrToken]);

  if (valido === null) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1a1a' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!valido) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1a1a', padding: 24, textAlign: 'center' }}>
        <div>
          <h2 style={{ color: '#ff4d4f' }}>Código QR inválido o vencido</h2>
          <p style={{ color: '#b0b0b0' }}>Escaneá el código QR del día en la terminal del club.</p>
        </div>
      </div>
    );
  }

  return <TerminalFichada modoPublico qrTokenInicial={qrToken} />;
};

export default FichadaPublica;
